/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1CourseregistrationEnrollmentPoloMutationResponse,
  PutApiV1CourseregistrationEnrollmentPoloQueryParams,
  PutApiV1CourseregistrationEnrollmentPolo400,
  PutApiV1CourseregistrationEnrollmentPolo401,
  PutApiV1CourseregistrationEnrollmentPolo500,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentPolo.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1CourseregistrationEnrollmentPolo } from "../../clients/courseRegistrationEnrollmentController/putApiV1CourseregistrationEnrollmentPolo.ts";

export const putApiV1CourseregistrationEnrollmentPoloMutationKey = () =>
  [{ url: "/api/v1/courseregistration/enrollment/polo" }] as const;

export type PutApiV1CourseregistrationEnrollmentPoloMutationKey = ReturnType<
  typeof putApiV1CourseregistrationEnrollmentPoloMutationKey
>;

export function putApiV1CourseregistrationEnrollmentPoloMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = putApiV1CourseregistrationEnrollmentPoloMutationKey();
  return mutationOptions<
    PutApiV1CourseregistrationEnrollmentPoloMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentPolo400
      | PutApiV1CourseregistrationEnrollmentPolo401
      | PutApiV1CourseregistrationEnrollmentPolo500
    >,
    { params?: PutApiV1CourseregistrationEnrollmentPoloQueryParams },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ params }) => {
      return putApiV1CourseregistrationEnrollmentPolo(params, config);
    },
  });
}

/**
 * @description Atualiza o polo vinculado a uma matrícula. Quando o polo informado existir, define PoloChangeManual como verdadeiro. Quando a turma tiver o polo bloqueado (IsPoloBlocked), a operação é ignorada sem erro. Requer permissão de empresa sobre a matrícula. **(Requer Authorization para autenticação)**
 * @summary Atualiza o polo de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/polo}
 */
export function usePutApiV1CourseregistrationEnrollmentPolo<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1CourseregistrationEnrollmentPoloMutationResponse,
      ResponseErrorConfig<
        | PutApiV1CourseregistrationEnrollmentPolo400
        | PutApiV1CourseregistrationEnrollmentPolo401
        | PutApiV1CourseregistrationEnrollmentPolo500
      >,
      { params?: PutApiV1CourseregistrationEnrollmentPoloQueryParams },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1CourseregistrationEnrollmentPoloMutationKey();

  const baseOptions = putApiV1CourseregistrationEnrollmentPoloMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1CourseregistrationEnrollmentPoloMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentPolo400
      | PutApiV1CourseregistrationEnrollmentPolo401
      | PutApiV1CourseregistrationEnrollmentPolo500
    >,
    { params?: PutApiV1CourseregistrationEnrollmentPoloQueryParams },
    TContext
  >;

  return useMutation<
    PutApiV1CourseregistrationEnrollmentPoloMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentPolo400
      | PutApiV1CourseregistrationEnrollmentPolo401
      | PutApiV1CourseregistrationEnrollmentPolo500
    >,
    { params?: PutApiV1CourseregistrationEnrollmentPoloQueryParams },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1CourseregistrationEnrollmentPoloMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentPolo400
      | PutApiV1CourseregistrationEnrollmentPolo401
      | PutApiV1CourseregistrationEnrollmentPolo500
    >,
    { params?: PutApiV1CourseregistrationEnrollmentPoloQueryParams },
    TContext
  >;
}
